import React from 'react'
import styled from 'styled-components'
import { WithAuth as Root } from '@/components/Root'
import { Layout, PageHeader, Form, Input, Button, Radio } from 'antd'
import { FormInstance } from 'antd/lib/form'

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 8 },
}

type Props = {
  form: FormInstance
  onPressSubmit: (values: any) => void
  isUploadingConsoleUser: boolean
}

const pageTitle = '新規管理サイトユーザー登録'

export default (props: Props) => {
  return (
    <Root title={pageTitle}>
      <Layout>
        <StyledPageHeader title={pageTitle} />
        <ContentBody>
          <Form {...layout} form={props.form} onFinish={props.onPressSubmit}>
            <Form.Item
              name="emailAddress"
              label="メールアドレス"
              rules={[{ required: true, message: 'メールアドレスは必須です' }]}>
              <Input placeholder="メールアドレス" />
            </Form.Item>
            <Form.Item name="role" label="権限" rules={[{ required: true, message: '権限は必須です' }]}>
              <Radio.Group>
                <Radio.Button value="admin">管理者</Radio.Button>
                <Radio.Button value="viewer">閲覧者</Radio.Button>
              </Radio.Group>
            </Form.Item>
            <Form.Item label=" " colon={false}>
              <Button type="primary" htmlType="submit" loading={props.isUploadingConsoleUser}>
                登録
              </Button>
            </Form.Item>
          </Form>
        </ContentBody>
      </Layout>
    </Root>
  )
}

const StyledPageHeader = styled(PageHeader)`
  margin: 16px 0;
  background-color: #fff;
`

const ContentBody = styled.div`
  background: #fff;
  padding: 24px;
  min-height: 360px;
`
